import { REQUEST_DIVISION_CANDIDATE_PRO } from '../../../define/consts/registration';
import { isRequiredText, isRequiredWithObjEqual, strMax } from '../../utils';
export const slideSearchRegistrationValidate = {
    position: [
        isRequiredWithObjEqual('役職を選択してください', 'requestDivision', REQUEST_DIVISION_CANDIDATE_PRO.value.toString()),
    ],
    positionOther: [
        isRequiredText('役職（その他）を入力してください'),
        strMax(50, '役職（その他）その他は50文字以内で入力してください'),
    ],
    requestDivision: [isRequiredText('所属組織を選択してください')],
};
export default slideSearchRegistrationValidate;
